// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.emailverification.RentalManagerUserEmailVerificationWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { RentalManagerVerificationEmailUnverifiedEmailListingsDto } from '../..';

interface GetUnverifiedEmailListingsParams {
  limit?: number;
}

export const RentalManagerUserEmailVerificationWebApiHandler_getUnverifiedEmailListings_Path =
  '/api/web/v1/users/emailVerification/getUnverifiedEmailListings';

/**
 * Get list of claimable listings if this user has an unverified email address
 */
export const RentalManagerUserEmailVerificationWebApiHandler_getUnverifiedEmailListings = (
  getParams: GetUnverifiedEmailListingsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    GetUnverifiedEmailListingsParams,
    never,
    RentalManagerVerificationEmailUnverifiedEmailListingsDto
  >(
    {
      getParams: getParams,
      endpoint: RentalManagerUserEmailVerificationWebApiHandler_getUnverifiedEmailListings_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
